import React from 'react';
import { ProductSection as ProductSectionType } from '../types/product';
import ProductItem from './ProductItem';
import { getCurrentLanguage } from '../config/languageConfig';
import { SupportedCurrency, getCurrencyFromLanguage } from '../utils/currencyUtils';

interface ShopNames {
  name: string;
  nameEn: string | null;
  nameKo: string | null;
  nameJa: string | null;
  nameZhCn: string | null;
  nameZhTw: string | null;
}

interface ProductSectionProps {
  section: ProductSectionType;
  shopId: string;
  shopName: string;
  shopMultiNames?: ShopNames;
  currency?: SupportedCurrency;
}

const ProductSection: React.FC<ProductSectionProps> = ({ 
  section, 
  shopId, 
  shopName,
  shopMultiNames,
  currency
}) => {
  // 현재 언어에 맞는 섹션 이름 가져오기
  const currentLang = getCurrentLanguage();
  const effectiveCurrency = currency || getCurrencyFromLanguage(currentLang);
  
  return (
    <div className="mb-6 pb-4 border-b border-gray-200">
      {/* 섹션 헤더 */}
      <div className="mb-4">
        {/* 섹션 제목 표시 */}
        <h2 className="text-xl font-bold text-gray-800 text-left">{section.name}</h2>
      </div>
      
      {/* 상품 아이템 목록 */}
      <div>
        {section.products.length === 0 ? (
          <p className="text-gray-500 italic">No items available in this section</p>
        ) : (
          <div>
            {section.products.map((product, index) => (
              <div key={product.id} className={index !== section.products.length - 1 ? "border-b border-gray-100" : ""}>
                <ProductItem 
                  product={product} 
                  shopId={shopId}
                  shopName={shopName}
                  shopMultiNames={shopMultiNames}
                  currency={effectiveCurrency}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductSection; 